import { render, staticRenderFns } from "./Behaviours.vue?vue&type=template&id=dab332c8&scoped=true&"
import script from "./Behaviours.vue?vue&type=script&lang=js&"
export * from "./Behaviours.vue?vue&type=script&lang=js&"
import style0 from "./Behaviours.vue?vue&type=style&index=0&id=dab332c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab332c8",
  null
  
)

export default component.exports